import { APP_ROUTES, USER_ROLES } from "../../constants"
import { NavItem } from "../../interfaces"

const AdminMenu: NavItem[] = [{
    icon: "fa fa-home",
    name: "Home",
    path: `/${APP_ROUTES.HOME}`
}, {
    icon: "fa fa-user-plus",
    name: "Broker Admin",
    path: `/${APP_ROUTES.BROKER_ADMIN}`
}, {
    icon: "fa fa-users",
    name: "Broker Groups",
    path: `/${APP_ROUTES.BROKER_GROUP}`
}, {
    icon: "fa fa-list",
    name: "Survey",
    path: `/${APP_ROUTES.SURVEY}`
// }, {
//     icon: "fa fa-id-badge",
//     name: "Personnel",
//     path: `/${APP_ROUTES.PERSONNEL}`
}]

const BrokerAdminMenu: NavItem[] = [{
    icon: "fa fa-home",
    name: "Home",
    path: `/${APP_ROUTES.HOME}`
}, {
    icon: "fa fa-user-plus",
    name: "Broker",
    path: `/${APP_ROUTES.BROKER}`
}, {
    icon: "fa fa-users",
    name: "Client",
    path: `/${APP_ROUTES.CLIENT}`
}, {
    icon: "fa fa-list",
    name: "Surveys",
    path: `/${APP_ROUTES.CONDUCT}`
// }, {
//     icon: "fa fa-id-badge",
//     name: "Personnel",
//     path: `/${APP_ROUTES.PERSONNEL}`
}]

const BrokerMenu: NavItem[] = [{
    icon: "fa fa-home",
    name: "Home",
    path: `/${APP_ROUTES.HOME}`
}, {
    icon: "fa fa-users",
    name: "Client",
    path: `/${APP_ROUTES.CLIENT}`
}, {
    icon: "fa fa-list",
    name: "Surveys",
    path: `/${APP_ROUTES.CONDUCT}`
}]

export const SIDEBAR_CONFIG = {
    [USER_ROLES.ADMIN]: AdminMenu,
    [USER_ROLES.BROKER_ADMIN]: BrokerAdminMenu,
    [USER_ROLES.BROKER]: BrokerMenu
}